// extracted by mini-css-extract-plugin
export var infoItem = "_rw-2";
export var title = "_rw-0";
export var value = "_rw-1";